// Used in tiles, assign-cart-side-panel, assignable-preview-details, mathia.component, resources-list, mathia-unit, assign-review-selected-assets, assignables-list

import { Injectable } from "@angular/core";
import { Asset, Bundle, CogTutorWorkspace } from "@carnegie-learning/cure-types";

interface Pacing {
    pacingX: number;
    pacingY: number;
}

export enum pacingTime {
    HOURS = "hours",
    MINUTES = "minutes",
}

@Injectable()
export class PacingHelper {
    getTotalPacingRange(selectedAssets: Asset[]): Pacing | undefined {
        let totalX = 0;
        let totalY = 0;
        if (selectedAssets) {
            selectedAssets.forEach((a) => {
                const tempA = <CogTutorWorkspace>a;
                if (tempA.minPacingSec && tempA.maxPacingSec) {
                    totalX = totalX + tempA.minPacingSec;
                    totalY = totalY + tempA.maxPacingSec;
                }
                if ((<Bundle>a).tasks) {
                    (<Bundle>a).tasks.forEach((c) => {
                        const tempC = <CogTutorWorkspace>c;
                        if (tempC.minPacingSec && tempC.maxPacingSec) {
                            totalX = totalX + tempC.minPacingSec;
                            totalY = totalY + tempC.maxPacingSec;
                        }
                    });
                }
            });
            return {
                pacingX: totalX,
                pacingY: totalY,
            };
        }
    }

    getTotalPacing(selectedAssets: Asset[]) {
        const range = this.getTotalPacingRange(selectedAssets);
        return this.formatTotalPacing(
            Number(range?.pacingX),
            Number(range?.pacingY)
        );
    }

    getAssetPacing(asset: CogTutorWorkspace | Bundle) {
        if (
            (<CogTutorWorkspace>asset).minPacingSec &&
            (<CogTutorWorkspace>asset).maxPacingSec
        ) {
            return (
                this.formatAssetPacingNumberOnly(
                    (<CogTutorWorkspace>asset).minPacingSec
                ) +
                " - " +
                this.formatAssetPacing((<CogTutorWorkspace>asset).maxPacingSec)
            );
        } else if ((<Bundle>asset).tasks) {
            // get pacing from Lesson's activities
            let pacingX = 0;
            let pacingY = 0;
            (<Bundle>asset).tasks.forEach((task) => {
                const tempTask = <CogTutorWorkspace>task;
                if (tempTask.minPacingSec && tempTask.maxPacingSec) {
                    pacingX += tempTask.minPacingSec;
                    pacingY += tempTask.maxPacingSec;
                }
            });
            return (
                this.formatAssetPacingNumberOnly(pacingX) +
                " - " +
                this.formatAssetPacing(pacingY)
            );
        } else {
            return "None Set";
        }
    }

    formatTotalPacing(
        totalX: number,
        totalY: number,
        duration: pacingTime = pacingTime.MINUTES,
        showTimeDescription = true
    ) {
        let time = 60;
        let timeDescription = " minutes";
        if (duration === pacingTime.HOURS) {
            time = 360;
            timeDescription = " hours";
        }
        timeDescription = showTimeDescription ? timeDescription : "";
        const pacingX = Math.floor(totalX / time);
        const pacingY = Math.floor(totalY / time);
        return pacingX + " - " + pacingY + timeDescription;
    }
    formatAssetPacing(pacingValue = 0) {
        const minutes = Math.floor(pacingValue / 60);
        if (minutes === 1) {
            return minutes + " minute";
        } else if (minutes < 1 || minutes > 1) {
            return minutes + " minutes";
        }
    }
    formatAssetPacingNumberOnly(pacingValue = 0) {
        return Math.floor(pacingValue / 60);
    }
    getMaxPacing(pacing: string): number {
        const arr = pacing.replace(/[^\d.-]/g, "").split("-");
        const maxPacing = Number(arr[arr.length - 1]);
        return maxPacing ? maxPacing : 0;
    }
}
